import axios from 'axios'
import router from '../router'

const generateAPIEndPoint = () => {

    if (process.env.NODE_ENV === 'production') {
        return 'https://clients.pjjazz.com/api/v2/bo/'
    }
    //return 'https://clients.pglaz.com/api/v2/bo/'

    return 'https://clients.pjjazz.com/api/v2/bo/'
}

export const API_ENDPOINT = generateAPIEndPoint()

const instance = axios.create({
    baseURL: API_ENDPOINT,
})
instance.interceptors.request.use(async(config) => {
    config.headers['Content-Type'] = 'application/json';
    let token = localStorage.getItem('AccessToken');
    return {
        ...config,
        headers: {
            ...config.headers,
            ...(token && { authorization: `Bearer ${token}` }),
        },
    }
});

instance.interceptors.response.use(async(response) => {
    if (response.data) {
        if (response.data.statusCode) {
            await router.push("/login").catch(() => {});
        }
    }
    return response.data;
}, async(error) => {
    if (error.response && error.response.data) {
        if (error.response.data.error) {
            await router.push("/login").catch(() => {});
        }
        return Promise.reject(error.response.data);
    }
    return Promise.reject({
        success: false,
        error: {
            message: "ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้ในขณะนี้"
        }
    })
});

export default instance;